export const GOOGLE_CAPTCHA_SITE_KEY = '6LdMs7UZAAAAALCW7N7Rhqo0THjnpWUxpCL5BuDk';
export const CSRF_TOKEN_COOKIE_KEY = 'csrftoken';
export const CSRF_TOKEN_HEADER_KEY = 'X-CSRFToken';
